@if (legalDocument(); as data) {
  @if (data.text) {
    <div class="wrapper page-privacy-policy">
      <div class="content">
        <section class="tos-section"
                 [innerHtml]="data.text">
        </section>
      </div>
    </div>
  }
}
